module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/Club Vistara SBI Card PRIME.89fd0242.png";